import { ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { HeadCell } from 'components/ui/EnhancedTable';
import useAxios from 'library/axios'; 
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { globalConfig } from 'config';

import {IApplicationSetup, IApplicationSetupSearch, IMailRequest } from '../models/ApplicationSetup';
import { IAppTheme, IAppLogo } from 'themes/commonStyles';
import { useRecoilValue } from 'recoil';
import { currentUserSessionAtom } from 'library/store';
import { ProductType } from '../models/Product';

const _ = () => {

    const axios = useAxios();

    const {language: lg, applicationSetup } = useRecoilValue(currentUserSessionAtom);


    const createApplicationSetup = async (applicationSetup: IApplicationSetup)  =>       
        await (await axios.post('/api/setup/applicationSetup/create', applicationSetup)).data;       
        
    const updateApplicationSetup = async (applicationSetup: IApplicationSetup)  =>       
        await (await axios.post('/api/setup/applicationSetup/update', applicationSetup)).data;     

    const sendMail = async (mailRequest: IMailRequest)  =>       
      await (await axios.post('/api/setup/applicationSetup/send-mail', mailRequest)).data;
        
    const getApplicationSetup = async (id  : number )  => {
        const {data} = (await axios.get(`/api/setup/applicationSetup/get-applicationSetup/${id}`));
        return await data;
    }

    const getApplicationSetups = async (criteria: IApplicationSetupSearch) : Promise<IApplicationSetup[]> => {
        const {companyName} = criteria;

        const {data} = (await axios.get(`/api/setup/applicationSetup/get-applicationSetups?companyName=${companyName}`));
        return await data;
    }

    const getApplicationTheme = async () : Promise<IAppTheme>  => {
      const {data} = (await axios.get(`/api/setup/applicationSetup/get-application-theme`));
      return await data;
    }

    const defineApplicationTheme = async (appTheme  : IAppTheme )  => 
      await (await axios.post('/api/setup/applicationSetup/define-application-theme', appTheme)).data;    
    
    const getApplicationLogo = async () : Promise<IAppLogo>  => {
      const {data} = (await axios.get(`/api/setup/applicationSetup/get-application-logo`));
      return await data;
    }

    const defineApplicationLogo = async (appLogo  : IAppLogo )  => 
      await (await axios.post('/api/setup/applicationSetup/define-application-logo', appLogo)).data; 
    
    const getWebsiteAuthImages = async (websiteApplicationApiToken: string) : Promise<{image_Url: string}[]> => {
            
      const {data} = (await axios.get(`${globalConfig.get().websiteApiUrl}/api/production/content/v1/${websiteApplicationApiToken}/auth-image/get-contents`));
      return await data;
    }

    const getDefaultProductType = () : ProductType => 
      applicationSetup.hasService? 'service': 
        applicationSetup.hasArticle ? 'article' : applicationSetup.hasPackaging? 'packaging':
          applicationSetup.hasFormation? 'formation' : applicationSetup.hasMaintenance ? 'maintenance' : 
            applicationSetup.hasContract ?'contract' : applicationSetup.hasRental ?'rental' : 
              applicationSetup.hasConsumption ? 'consumption': applicationSetup.hasShiping ? 'shiping' :
                applicationSetup.hasLaundry ? 'laundry': applicationSetup.hasExam ? 'exam': 'fee';
        
    return {
        createApplicationSetup,
        updateApplicationSetup,
        getApplicationSetup,        
        getApplicationSetups,

        getApplicationTheme,
        defineApplicationTheme,

        sendMail,

        getApplicationLogo,
        defineApplicationLogo,

        getWebsiteAuthImages,

        getDefaultProductType
        
    } 
}

export default _;


export const useBasicFilterApplicationSetup = ( onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IApplicationSetup) => void  ) => {

    const { getApplicationSetups } = _();
  
    const { t, i18n } = useTranslation();   
      
    const [headApplicationSetupCells, setHeadApplicationSetupCells]  = useState<HeadCell<IApplicationSetup>[]>([
      {id:'id', label : t('Id'),  display: true, type: 'numeric', width: 110 },
      {id:'companyName', label : t('Name'),  display: true, type: 'string', },
     
  
    ]); 
    const [filterElements,] = useState( [       
        {name: 'name', text: t('Name'), value: ''}, 
        {name: 'description', text: t('Description'), value: ''},     
      ]);    
  
    const [filteredApplicationSetups, ] = useState<IApplicationSetup[]>([]); 
  
    const onFilterButtonClick = async (filterElements: ITextFilterElement[]): Promise<IApplicationSetup[]> => {
              
      const companyName = filterElements.find( elt => elt.name === 'companyName')?.value || '';
           
      const arr = await getApplicationSetups( {companyName} );
      
      return arr;
    }
  
    const objKey: keyof IApplicationSetup = 'id';
  
    return {
      title: t('Application Setup'), headCells: headApplicationSetupCells, objKey,
      filterElements, rows: filteredApplicationSetups, 
      onFilterButtonClick, onRowDoubleClick
    }
  }


  